import { render, staticRenderFns } from "./ad_qunfeng.vue?vue&type=template&id=1c6be340&scoped=true"
import script from "./ad_qunfeng.vue?vue&type=script&lang=js"
export * from "./ad_qunfeng.vue?vue&type=script&lang=js"
import style0 from "./ad_qunfeng.vue?vue&type=style&index=0&id=1c6be340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6be340",
  null
  
)

export default component.exports